<ion-header>
  <ion-toolbar>
    <ion-icon *ngIf="showBackButton" (click)="goBack()" name="arrow-back-outline"></ion-icon>
    <img src="{{logoUrl}}" />
  </ion-toolbar>
</ion-header>